"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_USER_VIEWED_FRAGMENT = exports.VIDEO_STATUS_FRAGMENT = exports.VIDEO_FIELDS = exports.VIDEO_FILE_FIELDS = void 0;
const client_1 = require("@apollo/client");
exports.VIDEO_FILE_FIELDS = (0, client_1.gql) `
  fragment VideoFileFields on File {
    id
    title
    url
    videoId
    conceptId
  }
`;
exports.VIDEO_FIELDS = (0, client_1.gql) `
  ${exports.VIDEO_FILE_FIELDS}
  fragment VideoFields on Video {
    id
    demo
    status
    title
    museId
    startTime
    endTime
    thumbnail
    live
    description
    duration
    startTime
    endTime
    viewsToday
    views
    userViewed
    osceStation {
      id
      name
      hiddenName
    }
    concepts {
      id
      name
    }
    files {
      ...VideoFileFields
    }
  }
`;
// used in cache updator
exports.VIDEO_STATUS_FRAGMENT = (0, client_1.gql) `
  fragment VideoStatus on Video {
    status
  }
`;
exports.VIDEO_USER_VIEWED_FRAGMENT = (0, client_1.gql) `
  fragment VideoUserViewed on Video {
    userViewed
  }
`;
